// ============================================================================
// Aplicación de la licencia DevExtreme (Tarea 8.2 / Req 8.2).
// Runtime key compartida con el DAM. Se aplica al arrancar, antes del bootstrap.
// La key vive en devextreme-license.key.ts (no versionado).
// ============================================================================
import config from 'devextreme/core/config';
// La key la genera la CLI `devextreme-license` (script prebuild) en devextreme-license.key.ts.
// La CLI exporta la constante como `licenseKey`. Archivo NO versionado (.gitignore).
import { licenseKey as DEVEXTREME_LICENSE_KEY } from './devextreme-license.key';

export function applyDevExtremeLicense(): void {
  const key = (DEVEXTREME_LICENSE_KEY || '').trim();
  if (key.length > 0) {
    config({ licenseKey: key });
  }
}
